import { Injectable } from '@angular/core';
import { BoSpinnerService, BoToastrService } from 'src/@core/shared';
import { API } from '../config/api';
import { HttpClient } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { SUCCESS } from '../../../@shared/constants';
import { ErrorResponse, PaginationResponse } from '../config/common';
import { CreateConsignmentNoteRequest } from '../../http';
import { Observable } from 'rxjs';
import { ConsignmentNote } from '../../models';

@Injectable()
export class ConsignmentNoteService {

    constructor(private _http: HttpClient,
        private _spinner: BoSpinnerService,
        private _toastr: BoToastrService) {

    }
    public getConsignmnetNotes(isInternal:boolean, id?: string): Observable<ConsignmentNote[]> {
        return this._http.get<ConsignmentNote[]>(`${API.CONSIGNMENT_NOTE.GET_CONSIGNMENT_NOTE(id,isInternal)}`)
            .pipe(tap(() => this._spinner.hide()));

    }
    public create(model: CreateConsignmentNoteRequest): Observable<ConsignmentNote> {
        return this._http.post<ConsignmentNote>(`${API.CONSIGNMENT_NOTE.CREATE}`, model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.CREATE_CONSIGNMNET_NOTE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
    public delete(id: string) {
        return this._http.delete(API.CONSIGNMENT_NOTE.DELETE(id))
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.DELETE_CONSIGNMENT_NOTE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            )
    }
    public update(model: CreateConsignmentNoteRequest, id: string) {
        return this._http.put(API.CONSIGNMENT_NOTE.UPDATE(id), model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.UPDATE_CONSIGNMENT_NOTE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            )
    }

    // public getOneConsignment(id: string){
    //     return this._http.get<Consignment>(`${API.CONSIGNMENT.GET_ONE(id)}`)
    //         .pipe(tap(() => this._spinner.hide()));
    // } 
}
